// Core
import {authconfig} from './authconfig';
import {coreconfig} from './coreconfig';

// App
import {mainconfig} from './mainconfig';
import {catalogconfig} from './catalogconfig';
import {customerconfig} from './customerconfig';
import {ordersconfig} from './ordersconfig';
import {salesconfig} from './salesconfig';
import {inventoryconfig} from './inventoryconfig';
import {financeconfig } from './financeconfig';
import {formsconfig } from './formsconfig';
import {activityconfig} from './activityconfig';
import {filesconfig } from './filesconfig';

// Tools
import {reportconfig} from './reportconfig';
import {uploadconfig} from './uploadconfig';
import {apisconfig } from './apisconfig';
import {uiuxconfig} from './uiuxconfig';
import {eventsconfig} from './eventsconfig';
import {flowsconfig} from './flowsconfig';

export const serviceconfig = {
  ...authconfig,
  ...coreconfig,
  
  ...mainconfig,
  ...catalogconfig,
  ...customerconfig,
  ...ordersconfig,
  ...salesconfig,
  ...inventoryconfig,
  ...financeconfig,
  ...formsconfig,
  ...activityconfig,
  ...filesconfig,

  ...reportconfig,
  ...uploadconfig,
  ...apisconfig,
  ...uiuxconfig,
  ...eventsconfig,
  ...flowsconfig,
};
